<script>
import PackageCRABody from './package-cra-component'
export default {
  name: 'PackageLayout',
  components: { PackageCRABody },
  props: {
    componentDataObject: {
      type: Array,
      default() {
        return []
      },
    },
    fraudPlusPackageDetails: {
      type: Array,
      default() {
        return []
      },
    },
    disabledSection: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    updatePackageData(newData, index) {
      console.log('newData - ', newData, index)
      this.fraudPlusPackageDetails[index].fraudPlusCRAs = newData
      // this.$emit(
      //   'updatePackageData',
      //   this.fraudPlusPackageDetails,
      //   this.selectedsections
      // )
    },
  },
}
</script>
<template>
  <b-row>
    <b-col>
      <div
        v-for="selectedsections in componentDataObject"
        :key="selectedsections"
        class="accordion"
        role="tablist"
      >
        <b-card
          v-if="
            fraudPlusPackageDetails[selectedsections].fraudPlusCRAs.length > 0
          "
          no-body
          class="mb-1"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              v-b-toggle="'sections-accordion-' + selectedsections"
              block
              variant="default"
              class="text-left d-flex"
              :class="$style.noOutLine"
            >
              {{
                fraudPlusPackageDetails[selectedsections].fraudPlusSectionName
              }}
              <strong aria-hidden="true" class="ml-auto">
                <i class="fa fa-angle-up"></i>
                <i class="fa fa-angle-down"></i>
              </strong>
            </b-button>
          </b-card-header>
          <b-collapse
            :id="'sections-accordion-' + selectedsections"
            :visible="
              fraudPlusPackageDetails[selectedsections].fraudPlusCRAs.length > 0
            "
            role="tabpanel"
          >
            <PackageCRABody
              :selectedsections="selectedsections"
              :fraud-plus-package-details="
                fraudPlusPackageDetails[selectedsections].fraudPlusCRAs
              "
              :disabled-section="disabledSection"
              @updatePackageData="updatePackageData"
            ></PackageCRABody>
          </b-collapse>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>
<style lang="scss" module>
@import '@design';
.noOutLine {
  font-weight: bold;
  color: #000 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
